import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, map} from 'rxjs';
import {DataService} from '../data.service';
import { catchError } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AwsSimpleServiceService extends DataService {
  private baseURI = this.apiUri + '/file';
  private baseURIAuditTrail = this.apiUri + '/auditTrail/';
  constructor(http: HttpClient) {
    super(http);
    this.setUri(this.baseURI);
  }

  getAllS3Data(): Observable<any> {
    const url = this.baseURI + '/gets3objects';
    return this.http.get(url).pipe(catchError(this.handleError));
  }

  removeObjects(objects: any): Observable<any> {
    const url = this.baseURI + '/delete';
    return this.http.post<boolean>(url, objects);
  }

  searchByPrefix(prefix: string) {
    const url = this.baseURI + '/prefix';
    let params: HttpParams = new HttpParams();
    params = params.append('prefix', prefix);
    return this.http.get(url, {params: params});
  }

  createEmptyFolder(key: string) {
    const url = this.baseURI + '/createemptyobject';
    return this.http.post(url, key, {responseType: 'text'}).pipe(catchError(this.handleError));
  }

  downloadBykey(keyPath: string) {
    this.setUri(this.baseURI + '/download');
    let params: HttpParams = new HttpParams();
    params = params.append('keyPath', keyPath);
    return this.http.get(this.baseURI,
      {
        params: params,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'Content-Disposition': 'attachment'
        }
      });
  }

  uploadFile(file: File, keyPath: string) {
    const url = this.baseURI + '/uploadobject';
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', file.name);
    formData.append('keyPath', keyPath);
    return this.http.post(url, formData, {responseType: 'text'}).pipe(catchError(this.handleError));
  }

  downloadByObjectKey(keyPath: string){
    const url = this.baseURI + '/generates3presignurl';
    let params: HttpParams = new HttpParams();
        params = params.append('keyPath', keyPath);
    return this.http.get(url, {params: params}).pipe(catchError(this.handleError));
  }

  private getEventMessage(event: HttpEvent<any>, file: File) {
    console.log(event);
  }

  getAuditTrailListForS3Portal(): Observable<any> {
    const auditTrailListUrl = this.baseURIAuditTrail + '/s3audittrail';
    this.setUri(auditTrailListUrl);
    return this.get();
  }
}
